import service from "./lib"
import helpers from "./helpers"
import Facets from "./facets"

export default function(items, configuration) {
  configuration = configuration || {}

  // index facets
  let facets = new Facets(items, configuration.aggregations)

  return {
    /**
     * per_page
     * page
     * query
     * sort
     * filters
     */
    search(input) {
      input = input || {}

      /**
       * merge configuration aggregation with user input
       */
      input.aggregations = helpers.mergeAggregations(configuration.aggregations, input)

      return service.search(items, input, configuration, facets)
    },

    /**
     * returns list of similar elements to specified item id
     * id
     */
    similar(id, options) {
      return service.similar(items, id, options)
    },

    /**
     * returns list of elements for specific aggregation i.e. list of tags
     * name (aggregation name)
     * query
     * per_page
     * page
     */
    aggregation(input) {
      return service.aggregation(items, input, configuration, facets)
    },

    /**
     * reindex items
     * reinitialize fulltext search
     */
    reindex(newItems) {
      items = newItems
      facets = new Facets(items, configuration.aggregations)
    },
  }
}
